import { Component, Input, OnInit, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { QueryDefinitionDto } from '../../shared/dto/query-definition.dto';
import { ReportService } from '../../shared/report-service';
import { SortDirectionEnum, SortExpression } from 'src/app/shared/search-expression/sort-expression.dto';
import { SelectItem } from 'primeng/api';
import { ColumnDefinitionDto } from '../../shared/dto/column-definition.dto';
import { TranslationService } from 'src/app/shared';

@Component({
  selector: 'wl-query-tool-set-sort-order',
  templateUrl: './query-tool-set-sort-order.component.html',
  styleUrls: ['./query-tool-set-sort-order.component.less'],
    standalone: false
})
export class QueryToolSetSortOrderComponent implements OnInit {
  @Input() queryDefinition: QueryDefinitionDto;
  @Input() availableFields: Array<ColumnDefinitionDto>;
  @Output() onSortOrderChange = new EventEmitter<string>();
  sortDirections: Array<SelectItem>;

  constructor(private _translationService: TranslationService) {}

  ngOnInit(): void {
    setTimeout(() => {
      const ascString = this._translationService.getInstantTitlecase('reports.query-tool.set-sort-order.ascending');
      const descString = this._translationService.getInstantTitlecase('reports.query-tool.set-sort-order.descending');
      this.sortDirections = [
        { label: ascString, value: SortDirectionEnum.Asc } as SelectItem,
        { label: descString, value: SortDirectionEnum.Desc } as SelectItem,
      ];
    }, 1000);
  }

  addSortingRule() {
    this.queryDefinition.SortExpressions.push({} as SortExpression);
  }

  removeSortingRule(index: number) {
    this.queryDefinition.SortExpressions.splice(index, 1);
    this.onSortOrderChange.emit();
  }
  sortRuleChange(){
    this.onSortOrderChange.emit();
  }
}
